import { render, staticRenderFns } from "./AppStatus.vue?vue&type=template&id=70d7b5fa&"
import script from "./AppStatus.vue?vue&type=script&lang=js&"
export * from "./AppStatus.vue?vue&type=script&lang=js&"
import style0 from "./AppStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports